export default {
  next: 'המשך',
  back: 'חזרה',
  finish: 'סיום',
  reset: 'עריכת נתונים',
  of: 'מתוך'
};
